// extracted by mini-css-extract-plugin
export default {"upper":"upper-lLRUzj","shareIcon":"shareIcon-kXlFjp","faqUrl":"faqUrl-YeaBC0","title":"title-ufS_cl","tips":"tips-eSuwuY"};